import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import x from '../../assets/icons/close.svg'
import getPaymentCountries from '../../apis/getPaymentCountries'

const PaymentDetails = ({ payment, active, close }) => {
  const popupref = useRef(null)
  const [allowedCountries, setAllowedCountries] = useState([])

  // State to store payment details
  const [form] = useState({
    title: payment.title,
    type: payment.type || 'package',
    type_name_en: payment.type_name_en || '',
    type_name_ar: payment.type_name_ar || '',
    is_active: payment.is_active || 1,
  })

  // Fetch allowed countries when component mounts or payment.title changes
  useEffect(() => {
    const fetchAllowedCountries = async () => {
      try {
        const countries = await getPaymentCountries(payment.title)
        setAllowedCountries(countries)
      } catch (error) {
        console.error('Error fetching allowed countries', error)
      }
    }
    fetchAllowedCountries()
  }, [payment.title])

  // Close the popup if click happens outside the component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [close])

  // Lock body scroll when active
  useEffect(() => {
    document.body.style.overflow = active ? 'hidden' : 'auto'
  }, [active])

  return (
    <motion.div
      className="fixed inset-0 bg-overlay/30 w-screen z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className="w-1/3 min-h-10 bg-white rounded-lg flex flex-col"
      >
        <div className="flex justify-between items-center p-4 border-b border-darkBlue">
          <div className="text-lg font-bold">{payment.title} Details</div>
          <div onClick={close} className="cursor-pointer">
            <img src={x} alt="Close" className="w-5 h-5" />
          </div>
        </div>
        <div className="px-4 py-6 flex-1 overflow-y-auto">
          {/* Payment details section */}
          <div className="mb-6">
            <div className="mb-2">
              <span className="font-semibold">Type Name (English): </span>
              {form.type_name_en}
            </div>
            <div className="mb-2">
              <span className="font-semibold">Type Name (Arabic): </span>
              {form.type_name_ar}
            </div>
            <div className="mb-2">
              <span className="font-semibold">Type: </span>
              {form.type}
            </div>
            <div>
              <span className="font-semibold">Status: </span>
              {form.is_active === 1 ? 'Active' : 'Inactive'}
            </div>
          </div>

          {/* Allowed Countries Section */}
          <div>
            <h3 className="text-lg font-bold mb-3">Allowed Countries</h3>
            {allowedCountries && allowedCountries.length > 0 ? (
              <div className="flex flex-wrap gap-1 max-h-48 bg-overlay/20 rounded-sm p-2 overflow-y-auto">
                {allowedCountries.map((country, index) => (
                  <div
                    key={index}
                    className="px-3 py-1 border border-blueButton rounded-sm text-sm bg-blueButton/10 text-blueButton"
                  >
                    {country}
                  </div>
                ))}
              </div>
            ) : (
              <p>No allowed countries set.</p>
            )}
          </div>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default PaymentDetails
